import { render, staticRenderFns } from "./PerformanceCreationDialog.vue?vue&type=template&id=8487c3bc&"
import script from "./PerformanceCreationDialog.vue?vue&type=script&lang=js&"
export * from "./PerformanceCreationDialog.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceCreationDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports